import { Component, OnInit, OnDestroy, ViewChild, ElementRef, DoCheck, AfterViewInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SidenavService } from 'src/app/services/sidenav.service';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { Subscription } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Dimensions, ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { PlantService } from 'src/app/services/plant.service';
import { AddplantService } from 'src/app/services/addplant.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Plant } from 'src/app/model/plant.model';

@Component({
  standalone: false,
  selector: 'app-edit-plant-trees',
  templateUrl: './edit-plant-trees.component.html',
  styleUrls: ['./edit-plant-trees.component.scss'],
})
export class EditPlantTreesComponent
  implements OnInit, OnDestroy, DoCheck, AfterViewInit {
  @ViewChild('content', { static: true }) modalContent: ElementRef;
  @ViewChild('uploadImages', { static: false }) uploadImages: ElementRef;
  @ViewChild('plant-details', { static: false }) plantdetailsbutton: ElementRef;

  public mainPlant = new Plant();

  activeIds: string[] = ['form_row_01', 'form_row_02', 'form_row_03'];

  images = [];
  afterConvertFile: any = [];
  previousImageConvertFile: any = [];

  imageChangedEvent: any = '';
  croppedImage: any = '';
  currentProcessingImg: any = 0;
  imgId: any = 0;
  finalImageList: any = [];
  prakList: any = [];
  photoData: any = {};
  croppedImageFile: any = '';
  uploadData: any;
  photoId: any;

  plantId: string;
  plantDetails: any;
  imageObject = [];
  alldetails: any;
  vetationCount: number = 1;
  public selectedDocumentFile: any;
  public formData: any;

  private subscriptions = new Subscription();
  public accordianIcon = '../../../assets/images/icons/chevron_up.svg';

  myForm = new FormGroup({
    VegetationName: new FormControl(),
    Species: new FormControl(),
    ParkId: new FormControl(),
    file: new FormControl(),
    VegetationPhotos: new FormControl(),
    VegetationNotes: new FormArray([]),
    createdBy: new FormControl(),
    isActive: new FormControl(),
    vegetationNoteId: new FormControl(),
    vegetationPhotoId: new FormControl(),
  });

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private sideNavService: SidenavService,
    private appStateSrv: AppStateProvider,
    private modalService: NgbModal,
    private plantService: PlantService,
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private addplantService: AddplantService
  ) {
    this.myForm = this.formBuilder.group({
      VegetationName: ['', [Validators.required, Validators.maxLength(100)]],
      Species: ['', [Validators.required]],
      ParkId: ['', [Validators.required]],
      file: [''],
      VegetationPhotos: [''],
      VegetationNotes: this.formBuilder.array([]),
      createdBy: '',
      isActive: true,
      vegetationNoteId: '',
      vegetationPhotoId: '',
    });

    localStorage.setItem('expandNavLand', 'true');
    // const route = this.sideNavService.routingChunks({
    //   name: 'Landscaping and Vegetation',
    //   subNav: '0',
    //   subNavLink: '',
    // });
    // this.appStateSrv.setSideNavState(route);

    /* setTimeout(() => {
      this.activeIds = [
        'ngb-panel-0',
        'ngb-panel-1',
        'ngb-panel-2',
        'ngb-panel-3',
        'ngb-panel-4',
        'ngb-panel-5',
        'ngb-panel-6',
        'ngb-panel-7',
        'ngb-panel-8',
        'ngb-panel-9',
        'ngb-panel-10',
      ];
    }, 100); */
  }

  ngAfterViewInit(): void { }

  ngOnInit(): void {
    this.vetationCount = 1;
    this.route.params.subscribe((params) => {
      this.plantId = params['id'];
    });

    localStorage.setItem('plantId', this.plantId);

    // let inputElement: HTMLElement = this.plantdetailsbutton.nativeElement as HTMLElement;
    // inputElement.click();

    /* setTimeout(() => {
      this.activeIds = [
        'ngb-panel-0',
        'ngb-panel-1',
        'ngb-panel-2',
        'ngb-panel-3',
        'ngb-panel-4',
        'ngb-panel-5',
        'ngb-panel-6',
        'ngb-panel-7',
        'ngb-panel-8',
        'ngb-panel-9',
        'ngb-panel-10',
      ];
    }, 100); */
    localStorage.removeItem('expandNav');
    this.getParkDetails();
    this.getPlantDetails();
  }

  ngOnDestroy() {
    localStorage.removeItem('expandNavLand');
    this.subscriptions.unsubscribe();
  }

  ngDoCheck(): void {
    // setTimeout(() => {
    //   let inputElement: HTMLElement = this.plantdetailsbutton.nativeElement as HTMLElement;
    //   inputElement.click();
    // }, 1000);
    // console.log("do check");
  }

  moveToDetailsPage() {
    this.router.navigate(['/plant-details/' + this.plantId]);
  }

  VegetationNotes(): FormArray {
    return this.myForm.get('VegetationNotes') as FormArray;
  }

  newNotes(
    headline?: string,
    description?: string,
    vegetationNoteId?: string
  ): FormGroup {
    return this.formBuilder.group({
      headline: [headline ? headline : '', Validators.required],
      description: [description ? description : '', Validators.required],
      vegetationNoteId: [vegetationNoteId ? vegetationNoteId : '0'],
    });
  }

  newPhotos(): FormGroup {
    return this.formBuilder.group({
      photoData: [],
    });
  }

  addMore(): void {
    this.VegetationNotes().push(this.newNotes());
    // this.vegetationNotes = this.vegetationNotes;
  }

  removeBlock(i: number) {
    this.VegetationNotes().removeAt(i);
  }

  onFileChange(event: any, file?: any) {
    if (event.target.files && event.target.files[0]) {
      var filesAmount = event.target.files.length;

      for (let i = 0; i < filesAmount; i++) {
        var reader = new FileReader();
        reader.readAsDataURL(event.target.files[i]);

        reader.onload = (innerEvent: any) => {
          // this.imgId = this.imgId + 1;
          this.images.push({
            // imgId: this.imgId,
            imgBase64: innerEvent.target.result,
            imgFile: event.target.files[i],
            cropped: false,
          });

          this.myForm.patchValue({
            VegetationPhotos: this.images,
          });
        };
      }
      console.log(this.images);
    }
  }

  onSubmit(): void {
    this.uploadData = new FormData();

    this.myForm.patchValue({
      createdBy: localStorage.getItem('claAdminId'),
      isActive: true,
    } as any);

    for (let i = 0; i <= this.images.length - 1; i++) {
      this.afterConvertFile.push(
        this.dataURLtoFile(
          this.images[i].imgBase64,
          this.images[i].imgFile.name
        )
      );
    }

    let imgFileProperties = this.afterConvertFile.map(
      (img: any, filename: any) => {
        let properties = {
          photoData: img,
          vegetationPhotoName: img.name,
          vegetationPhotoId: '0',
        };
        return properties;
      }
    );

    console.log(imgFileProperties);

    const uploadData = new FormData();

    for (let i = 0; i <= imgFileProperties.length - 1; i++) {
      console.log(imgFileProperties);
      console.log(this.plantDetails?.vegetationPhotos);

      this.photoId = '0';

      uploadData.append(
        'VegetationPhotos[' + i + '].photoData',
        imgFileProperties[i].photoData
      );
      uploadData.append(
        'VegetationPhotos[' + i + '].vegetationPhotoName',
        imgFileProperties[i].vegetationPhotoName.split('?').at(0)
      );
      // uploadData.append('VegetationPhotos[' + i + '].vegetationPhotoId', imgFileProperties[i].vegetationPhotoId);
      uploadData.append('VegetationPhotos[' + i + '].vegetationPhotoId', '0');
    }
    for (let i = 0; i <= this.myForm.value.VegetationNotes.length - 1; i++) {
      uploadData.append(
        'VegetationNotes[' + i + '].headline',
        this.myForm.value.VegetationNotes[i].headline
      );
      uploadData.append(
        'VegetationNotes[' + i + '].description',
        this.myForm.value.VegetationNotes[i].description
      );
      // uploadData.append('VegetationNotes[' + i + '].vegetationNoteId', this.myForm.value.VegetationNotes[i].vegetationNoteId);
      uploadData.append('VegetationNotes[' + i + '].vegetationNoteId', '0');
    }

    uploadData.append('VegetationId', this.plantId);
    uploadData.append('VegetationName', this.myForm.value.VegetationName);
    uploadData.append('Species', this.myForm.value.Species);
    uploadData.append('ParkId', this.myForm.value.ParkId);
    uploadData.append('ModifiedBy', localStorage.getItem('claAdminId'));
    uploadData.append('IsActive', 'true');
    // uploadData.append('VegetationNotes', this.myForm.value.VegetationNotes);
    console.log(uploadData);

    this.myForm.patchValue({
      VegetationPhotos: imgFileProperties,
    });

    console.log(this.myForm.value);

    if (this.myForm.valid) {
      this.addplantService
        .updatePlantVegitation(uploadData)
        .subscribe((res) => {
          console.log(res);
          this.router.navigate(['/listplants/']);
        });
      // this.router.navigate(['/plant-details/', this.plantId]);
    } else {
      this.myForm.markAllAsTouched();
    }
  }

  removeImage(i: any) {
    console.log(i);
    this.images.splice(i, 1);
  }

  removeImageOld(i: any) {
    this.afterConvertFile.length = 0;
    this.plantDetails?.vegetationPhotos.splice(i, 1);

    for (let i = 0; i <= this.plantDetails?.vegetationPhotos.length - 1; i++) {
      // this.convertImageToBase64(this.plantDetails?.vegetationPhotos[i].vegetationPhotoPath, function (dataURL: any) {
      // });

      console.log(this.plantDetails?.vegetationPhotos[i].vegetationPhotoPath);

      fetch(this.plantDetails?.vegetationPhotos[i].vegetationPhotoPath)
        .then((response) => response.blob())
        .then((blob) => {
          var reader = new FileReader();
          // const url = URL.createObjectURL(blob);
          reader.readAsDataURL(blob);
          reader.onload = (innerEvent: any) => {
            this.afterConvertFile.push(
              this.dataURLtoFile(
                innerEvent.target.result,
                this.plantDetails?.vegetationPhotos[i].vegetationPhotoPath
                  .split('?')
                  .at(0)
                  .split('/')
                  .at(4)
              )
            );
          };
        });
    }

    console.log(this.afterConvertFile);

    if (this.plantDetails?.vegetationPhotos.length - 1 == -1) {
      this.afterConvertFile.length = 0;
    }
  }

  closeModal() {
    this.imageChangedEvent = null;
    this.modalService.dismissAll();
  }

  openModal(content: any, imgId: any) {
    this.cropImage(imgId + 1);
    this.modalService
      .open(content, {
        ariaLabelledBy: 'modal-basic-title',
        size: 'lg',
      })
      .result.then(
        (result) => {
          // this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  //get a Image using Image Id to crop
  //cropping process done here
  cropImage(imgId: any) {
    this.currentProcessingImg = imgId - 1;
    var imgObj = this.images[imgId - 1];

    //created dummy event Object and set as imageChangedEvent so it will set cropper on this image
    var event = {
      target: {
        files: [imgObj.imgFile],
      },
    };
    this.imageChangedEvent = event;
  }

  //Save Cropped Image locally
  SaveCropedImage() {
    this.images[this.currentProcessingImg].imgBase64 = this.croppedImage;
    this.images[this.currentProcessingImg].cropped = true;
    this.closeModal();
    // var imgObj = this.images[this.currentProcessingImg];
    // imgObj.imgBase64 = this.croppedImage;
    // this.finalImageList.push(imgObj.imgBase64);
    console.log('modal close', this.images);
  }

  /* SaveAllImages() {
    this.finalImageList = [];
    this.images.forEach((imgObject) => {
      this.finalImageList.push(imgObject.imgBase64);
    });
  } */

  imageCropped(event: ImageCroppedEvent) {
    console.log(event);
    this.croppedImage = event.base64;
  }

  imageLoaded() {
    // show cropper
  }

  cropperReady(sourceImageDimensions: Dimensions) {
    // cropper ready
  }

  loadImageFailed() {
    // show message
  }

  dataURLtoFile(dataurl: string, filename: any) {
    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[arr.length - 1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename.split('?').at(0), { type: mime });
  }

  convertImageToBase64(
    imgUrl: string,
    callback: { (dataURL: any): void; (arg0: string): any }
  ) {
    this.afterConvertFile.length = 0;
    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.height = image.naturalHeight;
      canvas.width = image.naturalWidth;
      ctx.drawImage(image, 0, 0);
      const dataUrl = canvas.toDataURL();
      callback && callback(dataUrl);
      // this.previousImageConvertFile.push({ 'dataUrl': dataUrl, 'imgUrl': imgUrl });
      let filename = imgUrl.substring(imgUrl.lastIndexOf('/') + 1); //imgUrl.lastIndexOf("/") + 1;
      // let filename = imgUrl.substr(index);
      this.afterConvertFile.push(this.dataURLtoFile(dataUrl, filename));
    };
    image.src = imgUrl;
  }

  //api calls
  getParkDetails() {
    this.plantService.getParkByCLAId().subscribe((res) => {
      if (res.isValid) {
        this.prakList = res.list;
      }
    });
  }

  //api calls
  getPlantDetails() {
    this.plantService.getPlantDetail(this.plantId).subscribe((res) => {
      if (res.isValid === true) {
        this.plantDetails = res.data;
        console.log(this.plantDetails?.vegetationName);

        this.mainPlant.VegetationName = this.plantDetails?.vegetationName;
        this.mainPlant.Species = this.plantDetails?.species;
        this.mainPlant.ParkId = this.plantDetails?.parkId;

        for (
          let i = 0;
          i <= this.plantDetails?.vegetationPhotos.length - 1;
          i++
        ) {
          this.imageObject.push({
            image: this.plantDetails?.vegetationPhotos[i].vegetationPhotoPath,
            thumbImage:
              this.plantDetails?.vegetationPhotos[i].vegetationPhotoPath,
          });
        }

        for (
          let i = 0;
          i <= this.plantDetails?.vegetationPhotos.length - 1;
          i++
        ) {
          // this.convertImageToBase64(this.plantDetails?.vegetationPhotos[i].vegetationPhotoPath, function (dataURL: any) {
          // });
          fetch(this.plantDetails?.vegetationPhotos[i].vegetationPhotoPath)
            .then((response) => response.blob())
            .then((blob) => {
              var reader = new FileReader();
              // const url = URL.createObjectURL(blob);
              reader.readAsDataURL(blob);
              reader.onload = (innerEvent: any) => {
                this.afterConvertFile.push(
                  this.dataURLtoFile(
                    innerEvent.target.result,
                    this.plantDetails?.vegetationPhotos[i].vegetationPhotoPath
                      .split('?')
                      .at(0)
                      .split('/')
                      .at(4)
                  )
                );
              };
            });
        }

        console.log(this.afterConvertFile);

        for (
          let i = 0;
          i <= this.plantDetails?.vegetationNotes.length - 1;
          i++
        ) {
          this.VegetationNotes().push(
            this.newNotes(
              this.plantDetails?.vegetationNotes[i].headline,
              this.plantDetails?.vegetationNotes[i].description,
              this.plantDetails?.vegetationNotes[i].vegetationNoteId
            )
          );
        }

        if (
          !this.plantDetails?.vegetationNotes ||
          this.plantDetails?.vegetationNotes == ''
        ) {
          this.addMore();
        }
      } else {
        this.plantDetails = [];
      }
    });
  }
}
function strToLower(parkId: any): string {
  throw new Error('Function not implemented.');
}
